import { ConfigEnvModesType, IDevConfigInterface } from "./interface";

const config: IDevConfigInterface = {
  env: {
    mode: import.meta.env.MODE as ConfigEnvModesType,
    version: import.meta.env.PACKAGE_VERSION,
  },
  defaults: {
    pageTitle: "Vetic VMS",
  },
  localStorage: {
    UI_THEME: {
      key: "ui_theme",
    },
    PINNED_PROFILES: {
      key: "pinned_profiles",
    },
    ACCESS_TOKEN: {
      key: "access_token",
    },
    PWL_FILTERS: {
      key: "pwl_filters",
    },
    USER_DETAILS: {
      key: "user_details",
    },
    CITY: {
      key: "city",
    },
    CLINIC_NAME: {
      key: "clinic_name",
    },
    CLINIC: {
      key: "clinic",
    },
    APP_VERSION: {
      key: "app_version",
    },
  },
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  },
};
export default config;
